import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
    name: string;
    age: number;
}

const user = createSlice({
    name: 'user',
    initialState: { name: 'Lee', age: 20 } as UserState,
    reducers: {
        changeName(state) {
            state.name = 'park';
        },
        increase(state, action: PayloadAction<number>) {
            state.age += action.payload;
        },
    },
});

export const { changeName, increase } = user.actions;

interface CartItem {
    id: number;
    imgurl: string;
    name: string;
    count: number;
}

const cart = createSlice({
    name: 'cart',
    initialState: [
        
    ] as CartItem[],
    reducers: {
        addCount(state, action: PayloadAction<number>) {
            const num = state.findIndex((a) => a.id === action.payload);
            if (num !== -1) {
                state[num].count++;
            }
        },
        decreaseCount(state, action: PayloadAction<number>) {
            const num = state.findIndex((a) => a.id === action.payload);
            if (state[num].count > 0) {
                state[num].count--;
            } else {
                alert('상품이 더 이상 없습니다.');
            }
        },
        addItem(state, action: PayloadAction<CartItem>) {
            const num = state.findIndex((a) => a.id === action.payload.id);
            if (num !== -1) {
                state[num].count++;
            } else {
                state.push(action.payload);
            }
        },
        deleteItem(state, action: PayloadAction<number>) {
            const num = state.findIndex((a) => a.id === action.payload);
            if (num !== -1) {
                state.splice(num, 1);
            }
        },
        sortName(state) {
            state.sort((a, b) => (a.name > b.name ? 1 : -1));
        },
    },
});
export const { addCount, decreaseCount, addItem, deleteItem, sortName } = cart.actions;


export default configureStore({
    reducer: {
        user: user.reducer,
        cart: cart.reducer,
    },
});
